import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { BranchYearDTO, IBranchYearDTO } from './branch.year.dto';
import { BranchYearJudgeRoundDTO, IBranchYearJudgeRoundDTO } from './branch.year.judge.round.dto';

export interface IBranchYearRoundDTO extends IBaseEntityDTO {
  round: number;
  branchYear: IBranchYearDTO;
  judgeAssignments: IBranchYearJudgeRoundDTO[];
}

export class BranchYearRoundDTO extends BaseEntityDTO implements IBranchYearRoundDTO {
  round: number;
  branchYear: IBranchYearDTO;
  judgeAssignments: IBranchYearJudgeRoundDTO[];
  constructor(data?: Partial<BranchYearRoundDTO>) {
    super(data);
    this.round = data?.round || 0;
    this.branchYear = new BranchYearDTO(data?.branchYear);
    this.judgeAssignments = data?.judgeAssignments
      ? data.judgeAssignments.map((judge) => new BranchYearJudgeRoundDTO(judge))
      : [];
  }
}
